import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest,HttpParams } from '@angular/common/http';
import { Injectable} from '@angular/core';
import { Observable } from 'rxjs';
import {ObjectTextSanitizer} from "src/app/shared/sanitizer/object-text-sanitizer";
  @Injectable()
  export class SanitizeInterceptor implements HttpInterceptor {
    
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      // Only intercept requests that typically have a body to sanitize
      if (req.method === 'POST' || req.method === 'PUT') {
        // Clone the request and replace the body with the sanitized version

          if (req.body instanceof HttpParams) {
            return next.handle(req);
          }

          let sanitizedBody: any;

          if (req.body instanceof FormData) {
            sanitizedBody = ObjectTextSanitizer.sanitizeFormData(req.body);
          } else {
            sanitizedBody = ObjectTextSanitizer.deepSanitize(req.body);
          }

          
          const safeReq = req.clone({
            body: sanitizedBody
          });

        return next.handle(safeReq);
      }

      // For other methods (GET, DELETE, etc.), just pass them through
      return next.handle(req);
    }

    
  }